import { render, staticRenderFns } from "./PositionTemplateInfoFix.vue?vue&type=template&id=fbe355d8&"
import script from "./PositionTemplateInfoFix.vue?vue&type=script&lang=js&"
export * from "./PositionTemplateInfoFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports